<template>
  <div>
    <p class="small">
      埋め込み文字を利用して、医院情報や飼い主様情報を設定可能です。 埋め込み文字は、
      <code>{{ '\{\{ 埋め込み表現 \}\}' }}</code> の形式で利用します。
    </p>
    <table class="table table-bordered small">
      <tbody>
        <tr>
          <th style="width: 100px; padding: .4em;">カテゴリ</th>
          <th style="width: 220px; padding: .4em;">埋め込み文字</th>
          <th style="padding: .4em;">例</th>
        </tr>
        <tr
          v-for="(item, expKey) in psAgreementEmbeddableTemplateDef"
          :key="item.colName"
        >
          <td style="padding: .4em;">
            {{ displayCategoryByModelName[item.modelName] || item.modelName }}
          </td>
          <td style="padding: .4em;">
            <code class="p-0">{{ '\{\{ ' + expKey + ' \}\}' }}</code>
          </td>
          <td style="padding: .4em;">
            <span class="text-muted p-0">例: </span>{{ item.example }}
          </td>
        </tr>
      </tbody>
    </table>

    <div v-pre></div>
  </div>
</template>

<script lang="ts">
import { psAgreementEmbeddableTemplateDef } from './psAgreementEmbeddableTemplateDef'

const displayCategoryByModelName = {
  ps_clinics: '医院情報',
  ps_agreement_requests: '飼い主様情報',
}

const example = `
{{#username}}
<p>ようこそ、{{ username }}さん</p>
{{/username}}

{{^username}}
<p>ログインしてください</p>
{{/username}}
`
export default {
  name: 'PsAgreementEmbeddableTemplateExplanation',
  computed: {
    psAgreementEmbeddableTemplateDef() {
      return psAgreementEmbeddableTemplateDef
    },
    displayCategoryByModelName() {
      return displayCategoryByModelName
    },
  },
}
</script>
